import { jsx as _jsx } from "react/jsx-runtime";
import { getCookie } from '#pplx/frontend/cookies/provider.js';
import * as BUILD_CAPABILITIES from '#pplx/frontend/deployment-capabilities/build.js';
import { withCapability } from '#pplx/frontend/deployment-capabilities/CapabilityGate.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { getPendingComputerAffiliateBind, PPLX_COMPUTER_AFFILIATE_PENDING_COOKIE, } from '#pplx/frontend/growth/computer-affiliate/storage.js';
import { useEffect } from 'react';
const PendingComputerAffiliateBind = Dynamic(async () => {
    // ast-grep-ignore: no-undestruct-await-import
    const mod = await import('#pplx/frontend/apps/ask/analytics/ComputerAffiliateBind.js');
    return { default: mod.ComputerAffiliateBind };
});
const EnabledComputerAffiliateBind = () => {
    useEffect(() => {
        // Expired handoffs may leave tab-local state; cleanup must not run in render.
        getPendingComputerAffiliateBind();
    }, []);
    // The marketing app writes this marker before navigating into the signup/app shell.
    if (!getCookie(PPLX_COMPUTER_AFFILIATE_PENDING_COOKIE))
        return null;
    return _jsx(PendingComputerAffiliateBind, {});
};
export const ComputerAffiliateBind = withCapability(BUILD_CAPABILITIES.advertising, EnabledComputerAffiliateBind);
//# sourceMappingURL=ComputerAffiliateBindLoader.js.map